import { Autocomplete, Button, Card, Checkbox, Input, Table, Typography } from '@mui/joy'
import React, { useEffect, useState } from 'react'
import { post, Token } from '../../../Script/Session';

function ViewPointsEntries({ data, update }) {
    const [create, setcreate] = useState();
    const [userlist, setuserlist] = useState();
    const [reasonlist, setreasonlist] = useState();
    const [checked, setchecked] = useState();
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        let response = post(body, "/userlist");
        const parsed = JSON.parse(response).result;
        parsed.push({ id: -1, name: "Alle Anwesenden Nutzer"});
        parsed.push({ id: -2, name: "Alle Abgemeldeten Nutzer"});
        setuserlist(parsed);
    }, []);

    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/punktekonto");
        let value = JSON.parse(response)?.result;
        let a = [];
        value.map((item) => {
            item.subkath.map((i) => {
                a.push(i);
            })
        })
        setreasonlist(a);
    }, []);
    const [selecteduser, setselecteduser] = useState();
    const [selectedreason, setselectedreason] = useState();
    const [alternativegrund, setalternativgrund] = useState();
    const [pointsinput, setpointsinput] = useState();
    function c() {
        if (!selecteduser) {
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "addpointentrie";
        body.targetuser = selecteduser.id;
        body.reason = checked ? alternativegrund : selectedreason.name;
        body.points = Number(pointsinput);
        body.targetid = data.id;
        let response = post(body, "/aktivitäten");
        console.log(response);
        update();
        setalternativgrund()
        setselectedreason()
        setselecteduser()
        setpointsinput()
        setchecked(false);
        setcreate(false);
    }
    if (!data?.editperms) {
        return (<Typography color='danger'>Keine Berechtigung</Typography>)
    }
    return (
        <>
            {
                create && (
                    <Card>
                        <Typography level="title-md">Punkteeintrag Erstellen</Typography>
                        <Autocomplete placeholder='Person wählen' options={userlist} getOptionLabel={(i) => i.name} value={selecteduser} onChange={(e, newv) => setselecteduser(newv)} />
                        <Checkbox checked={checked} onChange={(e) => setchecked(e.target.checked)} label="Alternativer Grund ?" />
                        {
                            checked ? (
                                <Input value={alternativegrund} onChange={(e) => setalternativgrund(e.target.value)} placeholder='Grund eingeben'></Input>
                            ) : (
                                <Autocomplete placeholder='Grund wählen' onChange={(e, newv) => {
                                    setselectedreason(newv); if (newv.bis === 0) {
                                        setpointsinput(newv.points);
                                    }
                                }} value={selectedreason} options={reasonlist} getOptionLabel={(i) => i.name} />
                            )
                        }
                        {
                            checked ? (
                                <Input type="number" value={pointsinput} onChange={(e) => setpointsinput(e.target.value)} placeholder="Punkte angeben" />
                            ) : selectedreason ? (
                                selectedreason.bis === 0 ? (
                                    <Typography color="danger">
                                        Punkte wurden vom Punktekonto definiert! Punkte: {selectedreason.points}
                                    </Typography>
                                ) : (
                                    <>
                                        <Typography color="danger">
                                            Für diese Begründung ist eine Punktzahl von {selectedreason.points} bis {selectedreason.bis} vorgesehen
                                        </Typography>
                                        <Input value={pointsinput} onChange={(e) => setpointsinput(e.target.value)} type="number" placeholder="Punkte angeben" />
                                    </>
                                )
                            ) : null
                        }
                        <Button onClick={() => c()} sx={{ width: "10%" }}>
                            Erstellen
                        </Button>
                    </Card>



                )
            }
            <Table>
                <thead>
                    <tr>
                        <th>Person</th>
                        <th>Punktzahl</th>
                        <th>Grund</th>
                        <th>Ersteller</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data?.punkteeinträge.sort((a, b) => b.time - a.time).map((item) => {
                            return (
                                <tr>
                                    <td>{item.targetname}</td>
                                    <td>{item.points}</td>
                                    <td>{item.reason}</td>
                                    <td>{item.erstellername}</td>
                                </tr>
                            )
                        })
                    }



                </tbody>
            </Table>
            <Button sx={{ mt: 4 }} onClick={() => setcreate(true)}>
                Erstellen
            </Button>
        </>
    )
}

export default ViewPointsEntries
